import { InvoiceModel } from './invoice.model';
export class InvoiceConceptModel {
  invoiceConceptId: number = 0;
  invoiceId: number = 0;
  invoice: InvoiceModel = new InvoiceModel();
  conceptInvoicingId: number = 0;
  storeId: number = 0;
  value: number = 0;
  ivaRate: number = 0;//Backend
  ivaValue: number = 0;//Backend
  reteFuenteRate: number = 0;//Backend
  reteFuenteValue: number = 0;//Backend
  reteIcaRate: number = 0;//Backend
  reteIcaValue: number = 0;//Backend
  discountRate: number = 0;
  discountValue: number = 0;
  debitNotesValue: number = 0;//Backend
  creditNotesValue: number = 0;//Backend
  promptPaymentRate: number = 0;//Backend
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}